import { render, staticRenderFns } from "./BillReport.vue?vue&type=template&id=7b274b88&"
import script from "./BillReport.vue?vue&type=script&lang=js&"
export * from "./BillReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports